// @flow
import React, { type Node } from 'react';
import { useTranslation } from 'react-i18next';

import Loading from 'app/common/components/Loader';
import type { Complex } from 'app/common/components/Cafeteria/dataTypes/order/Complex.types';
import { useCurrencySign } from 'app/common/components-next/currency';

import ComplexItem from '../../../../commonComponents/ComplexItem';
import styles from './FoodItems.module.scss';;


type Props = {
  complexes: Array<Complex>,
  checkedMap?: Map<string, any>,
  onCheckItem: (id: string) => void,
  loading?: boolean,
  disabled?: boolean,
}

const FoodItems = ({
  complexes,
  checkedMap,
  onCheckItem,
  loading,
  disabled: disabledAll,
}: Props): Node => {
  const { t } = useTranslation('cafeteria');
  const currency = useCurrencySign();
  const nothing = complexes.length === 0;

  return (
    <div className={styles.root}>
      {nothing && loading && <Loading />}

      {nothing && !loading && <div>
        {t('order_request_sales_put_on_food_empty', 'Продукция отсутствует')}
      </div>}

      {complexes.map(({
        id,
        title,
        dishes,
        cost,
        disabled,
        disabledReason,
      }) => (
        <ComplexItem
          key={id}
          id={id}
          title={title}
          dishes={dishes}
          cost={cost}
          currency={currency}
          onCheck={onCheckItem}
          checked={checkedMap && checkedMap.get(id)}
          loading={loading}
          disabled={disabledAll || disabled}
          disabledReason={disabledReason}
        />
      ))}

    </div>
  );
};

export default FoodItems;
